export const environmentRadarData = [
  {
    subject: "Water Use",
    biogasToElectricity: 65,
    gasification: 80,
    bioOilToElectricity: 45,
    min: 0,
    max: 100,
  },
  {
    subject: "Land Use",
    biogasToElectricity: 75,
    gasification: 60,
    bioOilToElectricity: 85,
    min: 0,
    max: 100,
  },
  {
    subject: "Energy Use",
    biogasToElectricity: 55,
    gasification: 90,
    bioOilToElectricity: 70,
    min: 0,
    max: 100,
  },
];

export const environmentRadarDatasets = [
  {
    dataKey: "biogasToElectricity",
    fillColor: "var(--color-very-dark-blue)",
    strokeColor: "var(--color-very-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "gasification",
    fillColor: "var(--color-dark-blue)",
    strokeColor: "var(--color-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "bioOilToElectricity",
    fillColor: "var(--color-light-blue)",
    strokeColor: "var(--color-light-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
];

export const environmentTableData = [
  {
    label: "Water Use",
    values: [2.04, 2.04, 2.04],
    unit: "",
  },
  {
    label: "Land Use",
    values: [-4.06, -4.06, -4.06],
    unit: " %",
  },
  {
    label: "Energy Use",
    values: [-4.06, -4.06, -4.06],
    unit: " %",
  },
];

export const environmentColors = [
  "var(--color-very-dark-blue)",
  "var(--color-dark-blue)",
  "var(--color-light-blue)",
];

export const environmentLegendLabels = [
  "Biogas To Electricity",
  "Gasification",
  "Bio-Oil To Electricity",
];

export const financeRadarData = [
  {
    subject: "Internal Rate of Return (IRR)",
    biogasToElectricity: 65,
    gasification: 80,
    bioOilToElectricity: 45,
    min: 0,
    max: 100,
  },
  {
    subject: "Return on Investment (ROI)",
    biogasToElectricity: 75,
    gasification: 60,
    bioOilToElectricity: 85,
    min: 0,
    max: 100,
  },
  {
    subject: "Benefit-to-Cost Ratio (BCR)",
    biogasToElectricity: 55,
    gasification: 90,
    bioOilToElectricity: 70,
    min: 0,
    max: 100,
  },
  {
    subject: "LOTR",
    biogasToElectricity: 45,
    gasification: 70,
    bioOilToElectricity: 60,
    min: 0,
    max: 100,
  },
  {
    subject: "Net Present Value (NPV)",
    biogasToElectricity: 80,
    gasification: 65,
    bioOilToElectricity: 75,
    min: 0,
    max: 100,
  },
  {
    subject: "Operating Cost Index",
    biogasToElectricity: 70,
    gasification: 85,
    bioOilToElectricity: 55,
    min: 0,
    max: 100,
  },
];

export const financeRadarDatasets = [
  {
    dataKey: "biogasToElectricity",
    fillColor: "var(--color-very-dark-blue)",
    strokeColor: "var(--color-very-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "gasification",
    fillColor: "var(--color-dark-blue)",
    strokeColor: "var(--color-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "bioOilToElectricity",
    fillColor: "var(--color-light-blue)",
    strokeColor: "var(--color-light-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
];

export const financeTableData = [
  {
    label: "Internal Rate of Return (IRR)",
    values: [2.04, 2.04, 2.04],
    unit: "",
  },
  {
    label: "Return on Investment (ROI)",
    values: [-4.06, -4.06, -4.06],
    unit: " %",
  },
  {
    label: "Benefit-to-Cost Ratio (BCR)",
    values: [32.01, 32.01, 32.01],
    unit: "",
  },
  {
    label: "LOTR",
    values: [2.04, 2.04, 2.04],
    unit: "",
  },
  {
    label: "Net Present Value (NPV)",
    values: [-4.06, -4.06, -4.06],
    unit: " %",
  },
  {
    label: "Operating Cost Index",
    values: [32.01, 32.01, 32.01],
    unit: "",
  },
];

export const financeColors = [
  "var(--color-very-dark-blue)",
  "var(--color-dark-blue)",
  "var(--color-light-blue)",
];

export const financeLegendLabels = [
  "Biogas To Electricity",
  "Gasification",
  "Bio-Oil To Electricity",
];

export const technologyBarData = [
  {
    category: "Operational Reliability",
    positiveMin: 0,
    positiveMax: 10,
  },
  {
    category: "Resource Recovery Potential",
    negativeMin: -10,
    negativeMax: 0,
  },
];

export const technologyBarDatasets = [
  {
    dataKey: "biogasToElectricity",
    fillColor: "var(--color-very-dark-blue)",
    strokeColor: "var(--color-very-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "gasification",
    fillColor: "var(--color-dark-blue)",
    strokeColor: "var(--color-dark-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
  {
    dataKey: "bioOilToElectricity",
    fillColor: "var(--color-light-blue)",
    strokeColor: "var(--color-light-blue)",
    fillOpacity: 0.3,
    strokeWidth: 2,
  },
];

export const technologyTableData = [
  {
    label: "Operational Reliability",
    values: [2.04, 2.04, 2.04],
    unit: "",
  },
  {
    label: "Resource Recovery Potential",
    values: [-5.06, -5.06, -5.06],
    unit: " %",
  },
];

export const technologyColors = [
  "var(--color-very-dark-blue)",
  "var(--color-dark-blue)",
  "var(--color-light-blue)",
];

export const technologyLegendLabels = [
  "Biogas To Electricity",
  "Gasification",
  "Bio-Oil To Electricity",
];

export const biogasCardListData = [
  { label: "Internal Rate of Return (IRR)", value: -4.06, unit: " %" },
  { label: "LOTR", value: 2.04 },
  { label: "Return On Investment (ROI)", value: -4.06, unit: " %" },
  { label: "Benefit-to-Cost Ratio (BCR)", value: 2.04 },
  { label: "Net Present Value", value: -12 },
  { label: "Operating Cost Index", value: 32.01 },
];

export const gasificationCardListData = [
  { label: "Internal Rate of Return (IRR)", value: 8.25, unit: " %" },
  { label: "LOTR", value: 3.15 },
  { label: "Return On Investment (ROI)", value: 12.45, unit: " %" },
  { label: "Benefit-to-Cost Ratio (BCR)", value: 1.85 },
  { label: "Net Present Value", value: 25 },
  { label: "Operating Cost Index", value: 28.75 },
];

export const fastPyrolysisCardListData = [
  { label: "Internal Rate of Return (IRR)", value: -2.18, unit: " %" },
  { label: "LOTR", value: 1.95 },
  { label: "Return On Investment (ROI)", value: -1.92, unit: " %" },
  { label: "Benefit-to-Cost Ratio (BCR)", value: 1.75 },
  { label: "Net Present Value", value: -8 },
  { label: "Operating Cost Index", value: 35.12 },
];

export const biogasNumberCardData = [
  { label: "Water Use", value: 80 },
  { label: "Land Use", value: 35 },
  { label: "Energy Use", value: 93 },
];

export const gasificationNumberCardData = [
  { label: "Water Use", value: 65 },
  { label: "Land Use", value: 85 },
  { label: "Energy Use", value: 120 },
];

export const fastPyrolysisNumberCardData = [
  { label: "Water Use", value: 95 },
  { label: "Land Use", value: 50 },
  { label: "Energy Use", value: 75 },
];

// DotCard Data
export const biogasDotCardData = {
  category: "Biogas to Electricity",
  title: "Technology",
  subtitle1: "Resource Recovery Potential",
  value: 70,
  unit: "KW hr per Ton",
  subtitle2: "Operational Reliability",
  score: 3,
};

export const gasificationDotCardData = {
  category: "Gasification",
  title: "Technology",
  subtitle1: "Resource Recovery Potential",
  value: 85,
  unit: "KW hr per Ton",
  subtitle2: "Operational Reliability",
  score: 4,
};

export const fastPyrolysisDotCardData = {
  category: "Fast Pyrolysis",
  title: "Technology",
  subtitle1: "Resource Recovery Potential",
  value: 62,
  unit: "KW hr per Ton",
  subtitle2: "Operational Reliability",
  score: 2,
};

export const scaleOptions = ["Small", "Medium", "Large"];
export const operationalLifeOptions = ["10 Years", "15 Years", "20 Years"];
export const truckCapacityOptions = ["Manual", "<5m³", "5-10 m³", ">10m³"];

export const domains = [
  { label: "Technology", enabled: true },
  { label: "Environment", enabled: true },
  { label: "Finance", enabled: true },
  { label: "Institutions", enabled: true },
  { label: "Market", enabled: true },
  { label: "People", enabled: true },
  { label: "See All", enabled: true },
];
